import { render, staticRenderFns } from "./TemplateTwo.vue?vue&type=template&id=6cd54c60&scoped=true"
import script from "./TemplateTwo.vue?vue&type=script&lang=js"
export * from "./TemplateTwo.vue?vue&type=script&lang=js"
import style0 from "./TemplateTwo.vue?vue&type=style&index=0&id=6cd54c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd54c60",
  null
  
)

export default component.exports